export class Constants {
	public static REQUEST_ID: string = "requestId";
	public static SESSION_ID: string = "sessionId";
	public static SESSION_ID_HEADER: string = "LEO_SESSION";
	public static REQUEST_ID_HEADER: string = "LEO_REQUEST";
}



// WEBPACK FOOTER //
// ./src/app/services/constants.ts